"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fill = exports.marginCenter = exports.pageWidth = exports.baseSpacing = void 0;

var _styledComponents = require("styled-components");

var baseSpacing = 12;
exports.baseSpacing = baseSpacing;
var pageWidth = 1264;
exports.pageWidth = pageWidth;
var marginCenter = (0, _styledComponents.css)(["margin-left:auto;margin-right:auto;"]);
exports.marginCenter = marginCenter;
var fill = (0, _styledComponents.css)(["height:100%;width:100%;"]);
exports.fill = fill;